/**
 * Created by Ivan on 17.03.2026
 */

const HungryGamesStartCompetitionWindow = Prefab.createWindow("hungry_games_start_competition_window", "hungrygamesstartcompetitionwindow_prefab_json");
